import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVICE,
    RETRIEVE_ARCHITECTURESERVICE,
    RETRIEVESINGLE_ARCHITECTURESERVICE,
    UPDATE_ARCHITECTURESERVICE,
    DELETE_ARCHITECTURESERVICE,
} from "./type";
import ARCService from "../service/arcService";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCService.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCService.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVICE,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCService.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVICE,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCService.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVICE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCService.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVICE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCService.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVICE,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCService.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVICE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};